export default __webpack_public_path__ + "static/media/RosaryAfternoon.3eb2f4fb.svg";